import {EFieldType} from 'entities/metadata';
import {TEntityValue} from 'modules/data';

export interface IUseFieldInitialValueProps {
    type: EFieldType;
    defaultValue?: TEntityValue;
}

export const getFieldInitialValue = ({type, defaultValue}: IUseFieldInitialValueProps) => {
    const isFieldWithoutDefaultValue = [
        EFieldType.REFERENCE,
        EFieldType.INPUT_WITH_DEFAULT_VALUE_SETTER,
    ].includes(type);

    return !isFieldWithoutDefaultValue ? defaultValue : undefined;
};
